export const NOTE_GET_MULTIPLE =  "NOTE_GET_MULTIPLE"
export const NOTE_GET_DROPDOWNS =  "NOTE_GET_DROPDOWNS"
export const NOTE_GET_ONE =  "NOTE_GET_ONE"
export const NOTE_REGISTER_SUCCESS =  "NOTE_REGISTER_SUCCESS"
export const NOTE_REGISTER_FAIL =  "NOTE_REGISTER_FAIL"
export const NOTE_LOADING =  "NOTE_LOADING"
export const NOTE_LOADING_ERROR =  "NOTE_LOADING_ERROR"
export const NOTE_ACTIVATE_FAIL =  "NOTE_ACTIVATE_FAIL"
export const NOTE_ACTIVATE_SUCCESS =  "NOTE_ACTIVATE_SUCCESS"
export const NOTE_UPDATE_SUCCESS =  "NOTE_UPDATE_SUCCESS"
export const NOTE_UPDATE_FAIL =  "NOTE_UPDATE_FAIL"
export const NOTE_DELETE_SUCCESS =  "NOTE_DELETE_SUCCESS"
export const NOTE_DELETE_FAIL =  "NOTE_DELETE_FAIL"
export const NOTE_EDIT =  "NOTE_EDIT"